import { styled } from '@mui/material';
import Button from '../button/Button';

export const ModalContentWrapper = styled('div')(({ theme }) => ({
  maxWidth: theme.spacings.unit(264),
  '& > div > div': {
    padding: `${theme.spacings.unit(10)} 
    ${theme.spacings.unit(9)} 
    ${theme.spacings.unit(4)} 
    ${theme.spacings.unit(9)}`,
  },
  'form > div': {
    padding: `${theme.spacings.unit(4)} ${theme.spacings.unit(9)}`,
  },
  'form > div div:last-child': {
    margin: 0,
  },
  'form > div:last-child > div': {
    padding: 0,
  },
  '& > div, form > div:last-child': {
    zIndex: 1,
    backgroundColor: theme.colors.white,
  },
  [theme.breakpointsMediaQuery.up('md')]: {
    [`
      & > div > div,
      form > div
    `]: {
      paddingLeft: theme.spacings.unit(15),
      paddingRight: theme.spacings.unit(15),
    },
  },
}));

export const FormRowGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacings.unit(4),
  marginBottom: theme.spacings.unit(4),
  [theme.breakpointsMediaQuery.up('md')]: {
    flexDirection: 'row',
    alignItems: 'end',
    margin: 0,
    marginBottom: theme.spacings.unit(8),
  },
}));

export const HeaderWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const Headnote = styled('h5')(({ theme }) => ({
  marginBottom: theme.spacings.unit(4),
  textTransform: 'uppercase',
}));

export const SubmitButton = styled(Button)(() => ({
  borderRadius: 0,
}));

export const GlobalError = styled('div')(({ theme }) => ({
  marginRight: theme.spacings.unit(1),
  fontSize: theme.fonts.utility.size(6),
  margin: `${theme.spacings.unit(1 / 4)} 0`,
  color: theme.colors.primaryError,
  minHeight: theme.spacings.unit(1.0625),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const MobileModalTitleStyled = styled('h3')(({ theme }) => ({
  margin: 0,
  padding: `0 ${theme.spacings.unit(9)} ${theme.spacings.unit(4)}`,
}));
